<button class="ddc-button-follow" color="{{ buttonColor }}" mat-flat-button (click)="toggleFollow()">
  {{ buttonText }}
</button>
